export default function(){
  return {
    ui: {
      theme: {
        possibles: [
          'light',
          'dark'
        ],
        choosed: 'light'
      }
    }
  }
}